var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { ArrayMinSize, IsArray, IsDateString, IsEnum, IsOptional, IsUUID, ValidateNested, } from 'class-validator';
import { AttendanceOutcome } from '../enums/attendance-outcome.enum.js';
import { CancellationOrigin } from '../enums/cancellation-origin.enum.js';
/**
 * Per-participant outcome a therapist records when confirming an appointment
 * (TM-9071). `deliveredAt` is intentionally NOT part of the input — the
 * server derives it from `scheduledStart + plannedDuration` (rückdatierbar),
 * so backdated confirmations record the true session date.
 */
export class ParticipantAttendanceOutcomeDto {
    patientId;
    attendance;
    /**
     * Who cancelled (TM-9737); only with `CANCELLED`. Absent ⇒ `PRACTICE`, what a client
     * from before TM-9737 meant by „Abgesagt".
     */
    origin;
    /** When the patient's Absage reached the practice; only with `origin = PATIENT`. Absent ⇒ now. */
    receivedAt;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], ParticipantAttendanceOutcomeDto.prototype, "patientId", void 0);
__decorate([
    IsEnum(AttendanceOutcome),
    __metadata("design:type", String)
], ParticipantAttendanceOutcomeDto.prototype, "attendance", void 0);
__decorate([
    IsOptional(),
    IsEnum(CancellationOrigin),
    __metadata("design:type", String)
], ParticipantAttendanceOutcomeDto.prototype, "origin", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    __metadata("design:type", String)
], ParticipantAttendanceOutcomeDto.prototype, "receivedAt", void 0);
export class ConfirmAppointmentDto {
    outcomes;
}
__decorate([
    IsArray(),
    ArrayMinSize(1),
    ValidateNested({ each: true }),
    Type(() => ParticipantAttendanceOutcomeDto),
    __metadata("design:type", Array)
], ConfirmAppointmentDto.prototype, "outcomes", void 0);
//# sourceMappingURL=confirm-appointment.dto.js.map